import { css } from "@emotion/css"
import { useEffect, useState } from "react"
import { EmailShareButton, FacebookShareButton, LineShareButton, TwitterShareButton } from "react-share"

import Skeleton from "@p-ban/common/src/components/Skeleton"
import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import useCouponCodeQuery from "../../../../api/coupon/useCouponCodeQuery"
import { createReferralLink } from "../../../../logic/coupon/referralLink"
import SideBarBox from "../components/SideBarBox"
import SideBarLabel from "../components/SideBarLabel"
import SideBarLink from "../components/SideBarLink"

import facebook from "./facebook.png"
import line from "./line.png"
import mail from "./mail.png"
import twitter from "./twitter.png"

const CouponShare = () => {
  const { couponCode = "", isFetching } = useCouponCodeQuery()

  const [url, setUrl] = useState("")
  useEffect(() => {
    setUrl(createReferralLink(couponCode).toString())
  }, [couponCode])

  const baseText = `P板.comで基板作成しませんか？
今なら新規登録で初回製造￥5,000引き！
お友達紹介キー：${couponCode}
▼いますぐこちらからユーザー登録▼`

  const mailSubject = "プリント基板に使える5,000円クーポンを進呈"
  const textWithURL = `${baseText}
${url}`

  return (
    <SideBarBox>
      <div className={styles.title}>お友達紹介キー</div>
      <div style={{ margin: "10px 0px" }}>
        <SideBarLabel>
          <Skeleton disabled={!isFetching}>
            <input
              readOnly
              value={couponCode}
              onFocus={(e) => {
                e.currentTarget.setSelectionRange(0, couponCode.length)
              }}
              className={styles.couponCode}
            />
          </Skeleton>
        </SideBarLabel>
      </div>
      <div className={styles.shareIconContainer}>
        <div className={styles.shareText}>シェア</div>
        <EmailShareButton url={url} subject={mailSubject} body={baseText} separator={"\n"}>
          <Image src={mail} alt="メールで共有する" />
        </EmailShareButton>
        <FacebookShareButton url={url}>
          <Image src={facebook} alt="facebookで共有する" />
        </FacebookShareButton>
        <TwitterShareButton url={url} title={baseText}>
          <Image src={twitter} alt="Twitterで共有する" />
        </TwitterShareButton>
        <LineShareButton url={url} title={textWithURL}>
          <Image src={line} alt="LINEで共有する" />
        </LineShareButton>
      </div>
      <Spacer size={6} />
      <SideBarLink href="/campaign/refer_friends.html">お友達紹介キーとは</SideBarLink>
    </SideBarBox>
  )
}

export default CouponShare

const styles = {
  title: css`
    padding: 0 6px;
    font-size: 13px;
    font-weight: bold;
  `,
  couponCode: css`
    width: 100%;
    font-family: inherit;
    font-size: 20px;
    font-weight: bold;
    color: #666666;
    text-align: center;
    background-color: transparent;
    border: none;
    outline: none;
  `,
  shareIconContainer: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 6px;
  `,
  shareText: css`
    height: 17px;
    font-size: 13px;
    line-height: 8px;
    color: #f7931e;
  `,
}
